import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { searchService } from '_services';
import { ActionNames, Errors, RouteDefs } from '_constants'
import { history } from '_helpers';

export const searchActions = {
    quickSearch: (searchStr) => dispatch => {
        dispatch(searchActions.quickSearchTyped(searchStr));
        if (searchStr.length > 2) {
            dispatch(searchActions.quickSearchRequest());
            searchService.quickSearch(searchStr)
                .then(
                    results => {
                        dispatch(searchActions.quickSearchSuccess(results));
                    },
                    error => {
                        dispatch(searchActions.quickSearchFailure({ searchStr: searchStr, error: error }));
                        dispatch(alertActions.error(Errors.SEARCH_QUICK_FAILURE));
                    }
                );
        }
    },
    quickSearchRequest: createAction(ActionNames.SEARCH_QUICK_REQUEST),
    quickSearchSuccess: createAction(ActionNames.SEARCH_QUICK_SUCCESS),
    quickSearchFailure: createAction(ActionNames.SEARCH_QUICK_FAILURE),

    quickSearchTyped: createAction(ActionNames.SEARCH_QUICK_TYPED),
    quickSearchClear: createAction(ActionNames.SEARCH_QUICK_CLEAR),

    search: (searchStr, page) => (dispatch, getState) => {
        dispatch(searchActions.searchTyped(searchStr));
        if (searchStr.length > 2) {
            dispatch(searchActions.searchRequest());
            searchService.search(searchStr, page, getState().entities.masterData.PROPS['PTERO_SEARCH_RESULTS_COUNT'].PRVALUE)
                .then(
                    results => {
                        dispatch(searchActions.searchSuccess(results));
                    },
                    error => {
                        dispatch(searchActions.searchFailure({ searchStr: searchStr, page: page, error: error }));
                        dispatch(alertActions.error(Errors.SEARCH_FAILURE));
                    }
                );
        }
    },
    searchRequest: createAction(ActionNames.SEARCH_REQUEST),
    searchSuccess: createAction(ActionNames.SEARCH_SUCCESS),
    searchFailure: createAction(ActionNames.SEARCH_FAILURE),

    searchTyped: createAction(ActionNames.SEARCH_TYPED),
    searchClear: createAction(ActionNames.SEARCH_CLEAR),

    searchDetails: (searchStr) => (dispatch, getState) => {
        dispatch(searchActions.searchTyped(searchStr));
        if (searchStr.length > 2) {
            dispatch(searchActions.searchRequest());
            searchService.search(searchStr, 1, getState().entities.masterData.PROPS['PTERO_SEARCH_RESULTS_COUNT'].PRVALUE)
                .then(
                    results => {
                        dispatch(searchActions.searchSuccess(results));
                    },
                    error => {
                        dispatch(searchActions.searchFailure({ searchStr: searchStr, error: error }));
                        dispatch(alertActions.error(Errors.SEARCH_FAILURE));
                    }
                );
        }
        history.push(RouteDefs.search.path);
    },

}
